module.exports = __webpack_public_path__ + "static/media/BobabarInteractiveApp.f783603d.mov";